<template>
	<div class="container">

		<!-- 选择年级和输入手机 -->
		<div class="flex-content">
			<img src="@/assets/wxPublic_top.png" class="flex-content-img" />
			<div class="flex-content-txt">
				<div>为了给您提供更好的服务</div>
				<div>请填写入学信息~</div>
			</div>
		</div>
		<div class="flex-form">
			<!-- <div class="flex-form-title">您孩子所在年级<span class="txt">(根据年级匹配课程)</span></div>
			<div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
				<div v-for="(item, index) in gradeList" :key="index" class="grade" @click="form.grade = item"
					:class="{ active: item == form.grade }">{{ item }}
					<img src="@/assets/wxPublic_top2.png" class="gouxuan" v-if="item == form.grade" />
				</div>
				<div class="grade" style="background-color: transparent !important;"></div>
			</div> -->

			<div class="flex-form-title">您的手机号<span class="txt" style="color: #fa6400;">(确认领课的唯一凭证)</span>
			</div>
			<div>
				<input clearable v-model="form.phone" class="phone" placeholder="为了确保正常上课，请填写手机号" type="tel" maxlength="11"
					:rules="rules" @focus="onFocus">
			</div>
			<div style="position: relative;" v-show="form.phone.length == 11 && form.phone != userPhoneSysn">
				<input clearable v-model="form.sms" type="tel" class="sms" placeholder="请输入验证码" maxlength="6"
					:rules="rules" @focus="onFocus">
				<div slot="button" class="code-text" @click="getCode">{{ msgs }}<span v-show="isSend">后重试</span>
				</div>
			</div>
		</div> 
		<div class="footer-fit" style="position: absolute;background-color: #fff;" v-if="btStatus">
			<div class="bottom2" @click="pay()">
				{{ detail.price <= 0 ? '免费领取课程' : '确认支付￥' + detail.price }} </div>
			</div>
		</div> 

</template>

<script>
var that;
import { checkStr } from '@/utils/validate'
import { Toast } from 'vant';
import wx from 'weixin-js-sdk'

export default {
	name: 'collect',
	components: {},
	props: {},
	data() {
		return {
			id: '',
			tid: '',
			btStatus: false,
			form: {
				phone: '',
				sms: '',
				grade:''
			},
			detail: {
				price: 0,
				courseDetail: ''
			},
			rules: [{
				required: true,
				message: '请输入手机号'
			}, {
				pattern: /^1\d{10}$/,
				message: '请输入正确的手机号'
			}],
			msgs: '获取验证码',
			token: '',
			isSend: false,
			orderId: '',
			status: '',
			isJump: false,
			timerTask: null,

			gradeList: ["大班", "一年级", "二年级", "三年级", "四年级", "五年级", "六年级", "其它"],
			userPhoneSysn: '',//用户之前下过订单的手机号
		}
	},
	created() {
		that = this
		that.id = this.$route.query.channel_id;
		that.tid = this.$route.query.tid || -1;
		that.token = localStorage.getItem('token') || '';
		that.userPhoneSysn = localStorage.getItem('userPhoneSysn') || '';
		that.form.phone = that.userPhoneSysn;
 
		// that.getConfig();
		that.getChannelsInfo();
		// that.getOrderDetail();
	},
	destroyed() {
		this.clearTask()
	},
	methods: {

		getConfig() {
			var that = this
			this.$http.post('/u/app/mp/config', {
				url: window.location.href
			}).then(res => {
				const result = res.data
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端
					appId: result.appId, // 必填，公众号的唯一标识
					timestamp: result.timestamp, // 必填，生成签名的时间戳
					nonceStr: result.nonceStr, // 必填，生成签名的随机串
					signature: result.signature, // 必填，签名
					jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
				})
				wx.ready(() => {
					console.log('配置成功-fail-<')
					that.getReady()
				})
				// 当配置不成功时执行
				wx.error(res => {
					// 输出错误信息
					console.log('-配置不成功-fail-<', res)
					if (res.errMsg && res.errMsg.includes('the permission value isoffline verifying')) {
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端
							appId: result.appId, // 必填，公众号的唯一标识
							timestamp: result.timestamp, // 必填，生成签名的时间戳
							nonceStr: result.nonceStr, // 必填，生成签名的随机串
							signature: result.signature, // 必填，签名
							jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
						})
						wx.ready(() => {
							console.log('配置成功2-fail-<')
							that.getReady()
						})
					}
				})
			})
		}, 

		getChannelsInfo() {
			var that = this;
			this.$http.get('/app/channels/getInfo', {
				id: that.id
			}).then(res => {
				console.log("数据" + res)
				that.detail = res.data
				that.btStatus = true;
				that.detail.detail = res.data.detail.replaceAll("<img ", "<img onclick='return false' ");
				document.title = res.data.title;
			}).catch(err => {
				setTimeout(() => {
					Toast('网络出现问题，请刷新重试!');
				}, 3000);
			})
		},

		//获取验证码
		getCode() {
			if (!this.form.phone) {
				this.$toast('请输入手机号')
				return
			}
			if (!checkStr(this.form.phone, 'mobile')) {
				this.$toast('请输入正确的手机号')
				return
			}
			if (this.isSend) return

			this.$http.post('/u/ali/sms', {
				phone: this.form.phone
			}).then(res => {
				this.$toast('验证码已发送')
				let count = 60
				this.isSend = true
				this.msgs = count + 's'
				this.timer = setInterval(() => {
					if (count === 1) {
						this.isSend = false
						this.msgs = '获取验证码'
						clearInterval(this.timer)
						return
					}
					count--
					this.msgs = count + 's'
				}, 1000)
			})
		},

		pay() {
			var that = this;
			if (!that.form.phone) {
				that.$toast('请输入手机号')
				return
			}
			if (!checkStr(that.form.phone, 'mobile')) {
				that.$toast('请输入正确手机号')
				return
			}
			if (that.form.phone != that.userPhoneSysn) {
				if (!that.form.sms) {
					that.$toast('请输入验证码')
					return
				}
			}

			//判断token存在
			that.token = localStorage.getItem('token')
			if (that.token) {
				that.getVerifyPhone()
			} else {
				//没有token就返回第一个页面
				let text = window.location.href;
				let url = text.replace("collect", "index");
				window.location.replace(encodeURIComponent(url)) 
				localStorage.removeItem('token')
				localStorage.removeItem('userPhoneSysn')
			}
		},

		//判断验证码是否正确后再下单
		getVerifyPhone() {
			var that = this;
			//用户当前输入的手机号和缓存中的手机号一致则重新获取验证码
			if (that.form.phone == that.userPhoneSysn) {
				that.getOrderDetail(true)
			} else {
				this.$http.post('/app/users/verifyPhone', {
					phone: that.form.phone,
					smsCode: that.form.sms
				}).then(res => {
					that.getOrderDetail(true)
				}).catch(err => {
					that.$toast(err.msg)
				})
			}
		},

		//下单
		addOrder() {
			var that = this;
			that.$http.post('/app/orders/add', {
				...that.detail,
				orderSource: '公众号',
				courseId: that.detail.courseId,
				phone: that.form.phone,
				grade: that.form.grade
			}).then(res => {
				localStorage.setItem('userPhoneSysn', that.form.phone)//下订单之后手机号码缓存到本地，用于下次回显无需验证码
				if (that.detail.price !== 0) {//订单不是免费的则调起微信支付
					that.orderId = res.data;
					that.createPay()
				} else {
					that.$toast('领取成功')
					setTimeout(() => {
						that.to_link()
					}, 500);
				}
			}).catch(err => {
				that.$toast(err.msg)
			})
		},

		//isPay 是否手动点支付
		getOrderDetail(isPay = false) {
			that = this
			that.$http.get('/app/channels/getOrder', {
				id: that.id,
			}).then(res => {
				if (!res.data) {//之前没有订单，去生成订单
					if (isPay) {
						that.addOrder()
					}
					return
				}
				that.orderId = res.data.id
				that.status = res.data.status

				// 状态(-1已取消0待付款1已付款)
				if (res.data.status === 1) {
					that.clearTask()

					if (isPay) {
						that.$toast('领取成功')
						setTimeout(() => {
							that.to_link()
						}, 500);
					}
				}

				if (res.data.status === 0) {
					that.form.phone = res.data.phone;
					if (isPay) {
						that.createPay()
					}
				}
			}).catch(err => {
				if(err.code==401){
					//token过期就返回第一个页面
					console.log('token过期就返回第一个页面')
					let text = window.location.href;
					let url = text.replace("collect", "index");
					window.location.replace(encodeURIComponent(url)) 
					localStorage.removeItem('token')
					localStorage.removeItem('userPhoneSysn')
				}
			})
		},

		//去支付的时候变成true，手动点去支付重新变成false
		createPay(isJump = false) {
			var that = this;
			that.isJump = isJump
			that.$http.post('/app/orders/createPay', {
				id: that.orderId,
				payType: 3
			}).then(res => {
				if (res.data) {
					that.isJump = true;
					const result = res.data
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: result.appId, // 必填，公众号的唯一标识
						timestamp: result.timeStamp, // 必填，生成签名的时间戳
						nonceStr: result.nonceStr, // 必填，生成签名的随机串
						signature: result.paySign, // 必填，签名
						jsApiList: ['chooseWXPay']
					})
					wx.ready(function () {
						wx.checkJsApi({
							jsApiList: ['chooseWXPay'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
							success: function () { }
						})
					})
					wx.chooseWXPay({
						timestamp: result.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
						nonceStr: result.nonceStr, // 支付签名随机串，不长于 32 位
						package: result.packageVal, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
						signType: result.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
						paySign: result.paySign, // 支付签名
						success(res) {
							console.log('支付成功', res)
							that.clearTask()
							that.$toast('支付成功')
							setTimeout(() => {
								that.to_link()
							}, 500);
						},
						cancel: (err) => {
							console.log('取消支付', err)
							that.$toast('取消支付')

							if (that.isJump) {
								// that.startTask()
							}
						},
						fail: (err) => {
							console.log('支付失败', err)
							that.$toast('支付失败')
							if (that.isJump) {
								// that.startTask()
							}
						}
					})
				}
			}).catch(() => {
				that.getChannelsInfo()
				that.getOrderDetail()
			})
		},

		startTask() {
			this.clearTask()
			// 定时 查看成功的
			this.timerTask = setInterval(() => {
				this.token = localStorage.getItem('token')
				if (!this.token) {
					this.clearTask()
					return
				}
				this.$http.get('/app/channels/getOrder', {
					id: this.id
				}).then(res => {
					if (!res.data) {
						return
					}
					this.orderId = res.data.id
					this.status = res.data.status
					if (res.data.status === 1) {
						this.clearTask()
						this.getOrderDetail()
					}
				})
			}, 2000)
		},


		clearTask() {
			clearInterval(this.timerTask)
			this.timerTask = null
		},

		to_link() {
			this.$router.push({
				path: '/vxPublic/success'
				// query: { id: this.id }
			})
		}, 
 
		getReady() {
			var that = this;
			let text = window.location.href;
			let shareUrl = text.replace("collect", "index");
			if (shareUrl.indexOf('code=') > 0) {
				shareUrl = shareUrl.match(/(\S*)&code=/)[1]
			}
			console.log('分享的链接', shareUrl)
			console.log('分享的内容', that.detail.courseName)
			wx.updateAppMessageShareData({
				title: `免费领>>5日趣味练字课`, // 分享标题
				desc: '5天写出漂亮字，每天练习15分钟，有1对1书法老师点评，让练字变简单！', // 分享描述
				link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl: 'https://mp.51xxc.com/courses/static/conrses_icon.png', // 分享图标
				success: function (res) {
					console.log('-22-分享success-<')
				},
				fail: e => {
					console.log('-22-分享fail-<', e)
				}
			})
			wx.updateTimelineShareData({
				title: `免费领>>5日趣味练字课`, // 分享标题
				desc: '5天写出漂亮字，每天练习15分钟，有1对1书法老师点评，让练字变简单！', // 分享描述
				link: shareUrl,
				imgUrl: 'https://mp.51xxc.com/courses/static/conrses_icon.png', // 分享图标
				success: function (res) {
					// 设置成功
					// wx.showMenuItems({
					//   menuList: ['menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3
					// })
					console.log('-33-分享success-<')
				},
				fail: e => {
					console.log('-33-分享fail-<', e)
				}
			})
		}, 

		// 获取地址栏的参数
		getQueryObj() {
			var query = window.location.search
			var queryObj = {}
			var arr = query.slice(1, query.length).split('&')
			arr.forEach(function (val) {
				var arr1 = val.split('=')
				queryObj[arr1[0]] = arr1[1]
			})
			return queryObj
		},

		onFocus(e) {
			setTimeout(() => {
				e?.target?.scrollIntoView({ block: "center", behavior: "smooth" });
			}, 400);
		}

	}
}
</script>

<style scoped lang="less">
.flex-form {
	position: relative;
	margin-top: -60px;
	background-color: #fff;
	border-radius: 0 50px 0 0;
	padding: 1px 40px 40px 40px;
	z-index: 2;
	height: 100vh;

	.flex-form-title {
		margin-top: 40px;
		font-size: 36px;
		font-weight: 600;
	}

	.phone {
		margin-top: 40px;
		border-radius: 20px;
		background-color: #f4f4f4;
		// padding: 30px 20px !important;
		font-size: 32px;

		width: 92%;
		padding: 30px;
		border: none !important;
	}

	.code-text {
		color: #ff6933;
		font-size: 32px !important;
		font-weight: 500 !important;
		position: absolute;
		top: 24px;
		right: 27px;
		bottom: 0;
		display: flex;
		align-items: center;
	}

	.sms {
		// position: relative;
		margin-top: 20px;
		background: #f5f5f5;
		border-radius: 20px;
		font-size: 32px;
		width: 92%;
		padding: 30px;
		border: none !important;
	}

	.active {
		box-shadow: inset 0 0 0 .026667rem #fe771b;
		font-weight: 700;
		color: #fa6400;
		background: #fc87291a !important;
		font-weight: 600 !important;
	}

	.grade {
		width: 30%;
		background-color: #f5f6f7;
		border-radius: 12px;
		height: 80px;
		line-height: 80px;
		text-align: center;
		font-size: 32px;
		color: #000;
		margin-top: 40px;
		position: relative;
		font-weight: 400;

		.gouxuan {
			position: absolute;
			top: 0;
			right: 0;
			width: 30px;
		}
	}

	.txt {
		font-size: 28px;
		color: #999;
		margin-left: 20px;
		font-weight: 500 !important;
	}
}

.flex-content {
	position: relative;


	.flex-content-img {
		width: 100%;
		display: block;
	}

	.flex-content-txt {
		position: absolute;
		top: 80px;
		left: 40px;
		color: #fff;
		font-size: 36px;
		font-weight: 600;
	}
}
  
.container {
	color: #333;
	font-size: 28px;
	height: 100%;
	display: flex;
	flex-direction: column; 
}
 
.footer-fit {
	flex-shrink: 0;
	width: 100%;
	bottom: 0;
	z-index: 2;
	background-color: #fff;

	.bottom2 {
		font-size: 40px;
		// padding-bottom: 60px;
		font-weight: bold;
		color: #fff;
		margin: 20px 40px 40px 40px;
		background: #ff6933;
		border-radius: 60px;
		padding: 20px;
		text-align: center;
	}
}

.van-popup {
	background: #f4f4f4;
}
</style>